export default {
    Get: {
        PERSON_MODEL: 'getPersonDetailModel',
    },
    Set: {
        PERSON_MODEL: 'setPersonDetailModel',
    }
  };